import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  data: {
    loading: false,
  },
  contextualLoading: {} as Record<string, boolean>,
  renderingLocalSpinner: false,
};

export type LoadingState = typeof initialState;

const slice = createSlice({
  name: 'loading',
  initialState,
  selectors: {
    selectLoading: (state: LoadingState) => {
      return state.data.loading;
    },
    selectIsContextualLoading: (state: LoadingState) => {
      return Object.keys(state.contextualLoading).length;
    },
    selectIsRenderingLocalSpinner: (state: LoadingState) => {
      return state.renderingLocalSpinner;
    },
  },
  reducers: {
    setLoading(state, { payload: bool }: PayloadAction<boolean>) {
      state.data.loading = bool;
    },
    startContextualLoading: {
      reducer: (state, action: PayloadAction<{ id: string }>) => {
        state.contextualLoading[action.payload.id] = true;
      },
      prepare: () => {
        const id = crypto.randomUUID();
        return { payload: { id } };
      },
    },
    endContextualLoading(state, { payload: id }: PayloadAction<string>) {
      delete state.contextualLoading[id];
    },
    setRenderingLocalSpinner(state, { payload: bool }: PayloadAction<boolean>) {
      state.renderingLocalSpinner = bool;
    },
    endAllContextualLoading(state) {
      state.contextualLoading = {};
    },
  },
});

export const loadingSelectors = slice.selectors;
export const loadingActions = slice.actions;
export const loadingReducer = slice.reducer;
